<template>
  <div class="modal" id="modal-add-adjustment" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add an Adjustment</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="addAdjustment">
          <div class="modal-body">

            <div class="form-group row mb-4">
              <label class="col-sm-2 col-form-label required">Name</label>
              <div class="col-sm-10">
                <input type="text" class="form-control" name="adjustment_name" v-model="name" maxlength="50" tabindex="1" required>
              </div>
            </div>
            <div class="form-group row mb-4">
              <label class="col-sm-2 col-form-label required">Type</label>
              <div class="col-sm-10">
                <button type="button" :class="'btn btn-outline-primary mr-3 ' + (type === 'fee' ? 'active' : '')" @click="type='fee'">Fee</button>
                <button type="button" :class="'btn btn-outline-primary mr-3 ' + (type === 'discount' ? 'active' : '')" @click="type='discount'">Discount</button>
              </div>
            </div>
            <div v-if="type" class="form-group row mb-0">
              <label class="col-sm-2 col-form-label required">{{ rateType === 'percentage' ? 'Rate' : 'Amount' }}</label>
              <div class="col-sm-10">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <button type="button" :class="'btn btn-outline-primary ' + (rateType === 'percentage' ? 'active' : '')" @click="rateType='percentage'">Percentage</button>
                    <button type="button" :class="'btn btn-outline-primary ' + (rateType === 'fixed' ? 'active' : '')" @click="rateType='fixed'">Value</button>
                  </div>
                  <div v-if="rateType === 'fixed'" class="input-group-prepend">
                    <span class="input-group-text">Rs.</span>
                  </div>
                  <input type="number" class="form-control" step="0.01" v-model="rate" @keypress.enter="addAdjustment" required>
                  <div v-if="rateType === 'percentage'" class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="rateType === 'percentage' && rate > 0.00" class="form-group row mt-4 mb-0">
              <label class="col-sm-2 col-form-label">Amount</label>
              <div class="col-sm-10">
                <input type="text" class="form-control-plaintext" :value="amount | numberToRs" readonly>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" class="btn btn-secondary">Close</button>
            <button type="submit" class="btn btn-primary" :disabled="!type || !name || !rateType || !rate || processing">
              <i v-if="processing" class="fas fa-circle-notch fa-spin"></i>
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import jQuery from 'jquery'

export default {
  name: 'Adjustment',
  data () {
    return {
      processing: false,
      type: null,
      name: null,
      rateType: 'percentage',
      rate: null
    }
  },
  computed: {
    amount: function () {
      if (!this.$parent.cart) {
        return null
      }

      let amount

      if (this.rateType === 'percentage') {
        amount = this.$parent.cart.sub_total * this.rate / 100
      } else {
        amount = this.rate
      }

      return amount
    }
  },
  methods: {
    addAdjustment () {
      if (!this.type || !this.name || !this.rateType || !this.rate) {
        this.$toast.error('Please fill the form properly')
        return
      }

      let adjustment = {
        type: this.type,
        name: this.name,
        rate_type: this.rateType,
        rate_base: 'sub_total',
        rate: parseFloat(this.rate),
        include_cart: true
      }

      this.processing = true
      axios.post(process.env.URLS_POS_API + '/cart/' + this.$parent.cart.id + '/totals', adjustment).then((response) => {
        this.$parent.cart = response.data.data.cart

        this.type = null
        this.name = null
        this.rateType = 'percentage'
        this.rate = null

        jQuery('#modal-add-adjustment').modal('hide')
      }).catch(error => {
        this.$toast.error('Failed to add the adjustment.' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)
      }).finally(() => {
        this.processing = false
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sale/partials/Adjustments.vue